import { default as app, collapsibleHeaderClickEvent, onWindowResize, resetSelectionColumn, ToggleYellowToGreen, ToggleGreenToYellow, IsUndefinedOrNull } from '@legacy/App';
 
 app.factory('DeviceProductFactory', ['$http', 'settings', function ($http, settings) {
    return {
        getNewDeviceProduct: function () {
            return $http.get(settings.ApiURL + settings.DeviceProductURL + "/newDeviceProduct");
        },        
        getDeviceProductDetails: function (artnr, deviceid, productid) {
            return $http.get(settings.ApiURL + settings.DeviceProductURL + "/details/" + encodeURIComponent(artnr) + "/" + deviceid + "/" + productid + '?noCache=' + new Date().getTime());
        },
        saveDeviceProduct: function (DeviceProduct) {
            return $http.put(settings.ApiURL + settings.DeviceProductURL, DeviceProduct);
        },
        deleteDeviceProduct: function (artnr, deviceid, productid) {
            return $http.delete(settings.ApiURL + settings.DeviceProductURL + "/" + encodeURIComponent(artnr) + "/" + deviceid + "/" + productid);
        },
        getDeviceProductList: function () {
            return $http.get(settings.ApiURL + settings.DeviceProductURL);
        },        
        getProductDropdown: function () {
            return $http.get(settings.ApiURL + settings.ProductURL + "/dropdown/0");
        },        
        getDeviceDropdown: function () {
            return $http.get(settings.ApiURL + settings.DeviceURL + "/dropdown");
        }
    };
}]);

app.controller('DeviceProductController', ['$q', '$scope', 'DeviceProductFactory', 'CompanyFactory', '$rootScope', 'settings', "masterFactory",
                            function ($q, $scope, DeviceProductFactory, CompanyFactory, $rootScope, settings, masterFactory) {
                                $rootScope.pageTitle = "Device Product Mapping";
                                $scope.companyDropdown = [];
                                $scope.dangerousgoodsDropdown = [];
                                $scope.DeviceProductList = [];
                                $scope.productDropdown = [];
                                $scope.deviceDropdown = [];                                
                                $scope.DeviceProduct = {};
                                $scope.newDeviceProduct = {};                                
                                $scope.error = "";
                                $scope.modelState = [];
                                $scope.isFormVisible = false;
                                $scope.pageSize = 20;

                                // Initialization - this runs on load
                                var init = function (pageIndex) {
                                    masterFactory.verifyAuthentication();

                                    $('#loadingModal').modal({ backdrop: 'static' });
                                    $q.all([                                        
                                        DeviceProductFactory.getProductDropdown().success(function (data) {
                                            $scope.productDropdown = data;
                                        }).error(function (data, status) {
                                            masterFactory.setError(status, data, $scope);
                                        }),                                        
                                        DeviceProductFactory.getDeviceDropdown().success(function (data) {
                                            $scope.deviceDropdown = data;
                                        }).error(function (data, status) {
                                            masterFactory.setError(status, data, $scope);
                                        }),
                                        DeviceProductFactory.getNewDeviceProduct().success(function (data) {
                                            $scope.newDeviceProduct = data;
                                        }).error(function (data, status) {
                                            masterFactory.setError(status, data, $scope);
                                        })
                                    ]).then(function () {
                                        DeviceProductFactory.getDeviceProductList().success(function (data) {
                                            $scope.DeviceProductList = data;
                                            $scope.refreshGrid(0);
                                        }).error(function (data, status) {
                                            masterFactory.setError(status, data, $scope);
                                        }).finally(function () {
                                            $('#loadingModal').modal('hide');
                                        });
                                    });
                                };

                                var getDeviceProductDetails = function (artnr, deviceid, productid) {
                                    DeviceProductFactory.getDeviceProductDetails(artnr, deviceid, productid).success(function (data) {
                                        $scope.DeviceProduct = data;
                                    }).error(function (data, status) {
                                        masterFactory.setError(status, data, $scope);
                                    });
                                };

                                init(0);

                                // Grid renderers
                                $scope.refreshGrid = function (PageIndex) {
                                    $('#gridDeviceProduct').dxDataGrid({
                                        dataSource: {
                                            store: {
                                                data: $scope.DeviceProductList,
                                                type: 'array',
                                                key: ['DeviceId', 'ProductId', 'ProductNameNumber']
                                            }
                                        },
                                        noDataText: "No Device Product Mapping Found",
                                        showColumnLines: true,
                                        showRowLines: false,
                                        showBorders: true,
                                        rowAlternationEnabled: false,
                                        contentReadyAction: grdReadyAction,
                                        selection: { mode: 'single' },
                                        paging: {
                                            pageSize: $scope.pageSize,
                                            pageIndex: PageIndex
                                        },
                                        scrolling: {
                                            mode: 'standard'
                                        },
                                        pager: {
                                            showPageSizeSelector: true,
                                            allowedPageSizes: [10, 20, 30]
                                        },
                                        filterRow: {
                                            visible: true
                                        },
                                        groupPanel: {
                                            visible: false,
                                        },
                                        columns: [                                           
                                            {
                                                caption: 'Product Name on Register', dataField: 'ProductNameOnDevice', cssClass: 'ProductNameOnDevice', alignment: 'center',
                                                dataType: 'string',
                                                cellTemplate: function (container, options) {
                                                   $('<span />')
                                                   .text(options.data.ProductNameOnDevice)
                                                   .appendTo(container);
                                                   container.addClass('grid-cell-align-left');
                                                }
                                            },
                                            {
                                                caption: 'Product ID on Register', dataField: 'ProductNameNumber', cssClass: 'ProductNameNumber', alignment: 'center',
                                                dataType: 'string',
                                                cellTemplate: function (container, options) {
                                                   $('<span />')
                                                   .text(options.data.ProductNameNumber)
                                                   .appendTo(container);
                                                   container.addClass('grid-cell-align-left');
                                               }
                                            },
                                            { caption: 'Product Unit', dataField: 'UnitOfProduct', cssClass: 'UnitOfProduct', dataType: 'string', alignment: 'center' },                                            
                                            {
                                                caption: 'Device Id - Name', dataField: 'DeviceId', cssClass: 'DeviceId', dataType: 'string', alignment: 'center',
                                                cellTemplate: function (container, options) {
                                                    var devicedetails = "";
                                                    if (options.data.DeviceId != 0) devicedetails = devicedetails + options.data.DeviceId + " - ";
                                                    if (options.data.DeviceName != null) devicedetails = devicedetails + options.data.DeviceName;
                                                    $('<span />').text(devicedetails).append("</br>").appendTo(container);                                                    
                                                }
                                            },                                            
                                            {
                                                caption: 'Product Number - Name', dataField: 'ProductName', cssClass: 'ProductName', dataType: 'string', alignment: 'center',
                                                cellTemplate: function (container, options) {                                                                                                        
                                                    $('<span />').text(options.data.ProductNumber + " - " + options.data.ProductName).append("</br>").appendTo(container);                                                    
                                                }
                                            }
                                        ],
                                        selectionChanged: function (selectedRowsInfo) {
                                            if (selectedRowsInfo.selectedRowsData[0] != null) {
                                                getDeviceProductDetails(selectedRowsInfo.selectedRowsData[0].ProductNameNumber,
                                                    selectedRowsInfo.selectedRowsData[0].DeviceId,
                                                    selectedRowsInfo.selectedRowsData[0].ProductId);
                                            }
                                            else {
                                                $scope.DeviceProduct = angular.copy($scope.newDeviceProduct);
                                            }
                                            $scope.isFormVisible = true;
                                            $scope.isDeleteVisible = true;
                                            ToggleYellowToGreen();
                                            $rootScope.pageTitle = "Device Product Mapping";
                                        }
                                    });
                                };

                                // Button click functions and submit form function
                                $scope.addNewDeviceProduct = function () {
                                    $rootScope.pageTitle = "New Device Product Mapping";                                   
                                    $scope.isFormVisible = true;
                                    $scope.isDeleteVisible = false;
                                    $scope.DeviceProduct = angular.copy($scope.newDeviceProduct);
                                    ToggleGreenToYellow();
                                };

                                $scope.confirmDeleteEntity = function () {
                                    $('#DeleteModal').modal({ backdrop: 'static' });
                                };

                                $scope.deleteEntity = function (value) {
                                    if (value == 0) {
                                        $('#DeleteModal').modal('hide');
                                    }
                                    else if (value == 1) {
                                        DeviceProductFactory.deleteDeviceProduct($scope.DeviceProduct.ProductNameNumber,
                                                    $scope.DeviceProduct.DeviceId,
                                                    $scope.DeviceProduct.ProductId).success(function (data) {
                                            DeviceProductFactory.getDeviceProductList().success(function (data) {
                                                var dataGrid = $('#gridDeviceProduct').dxDataGrid('instance');
                                                var pageIndex = dataGrid.pageIndex();
                                                $scope.pageSize = dataGrid.pageSize();
                                                $scope.DeviceProductList = data;
                                                $scope.cancelForm();
                                                $scope.refreshGrid(pageIndex);
                                            }).error(function (data, status) {
                                                masterFactory.setError(status, data, $scope);
                                            }).finally(function () {
                                                $scope.notify.add({ type: 'success', title: 'Success!', body: 'Deleted Device Product mapping successfully' });
                                            });
                                        }).error(function (data, status) {
                                            masterFactory.setError(status, data, $scope);
                                        }).finally(function () {
                                            $('#DeleteModal').modal('hide');
                                        });
                                    }
                                };

                                $scope.cancelForm = function () {
                                    var dataGrid = $('#gridDeviceProduct').dxDataGrid('instance');
                                    dataGrid.clearSelection();
                                    $scope.isFormVisible = false;
                                    $scope.DeviceProductForm.submitted = false;
                                    $scope.closeModelStateErrors();
                                    $scope.closeAlert();
                                };

                                $scope.reset = function (type) {
                                    if (type == 'update') {                                         
                                        getDeviceProductDetails($scope.DeviceProduct.ProductNameNumber,
                                                    $scope.DeviceProduct.DeviceId,
                                                    $scope.DeviceProduct.ProductId);
                                    }
                                    else {
                                        angular.copy($scope.newDeviceProduct, $scope.DeviceProduct);
                                    }
                                    $scope.DeviceProductForm.$setPristine();
                                    $scope.DeviceProductForm.submitted = false;
                                    $scope.closeModelStateErrors();
                                    $scope.closeAlert();
                                    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Device Product details were reset' });
                                };

                                $scope.submitForm = function () {
                                    if ($scope.DeviceProductForm.$valid) {
                                        $scope.saveDeviceProduct();
                                        $scope.DeviceProductForm.submitted = false;
                                    } else {
                                        $scope.DeviceProductForm.submitted = true;
                                    }
                                };

                                $scope.saveDeviceProduct = function () {
                                    $('#loadingModal').modal({ backdrop: 'static' });
                                    var pageindex, id;
                                    $scope.closeModelStateErrors();
                                    DeviceProductFactory.saveDeviceProduct($scope.DeviceProduct).success(function (data) {
                                        DeviceProductFactory.getDeviceProductList().success(function (data) {
                                            var dataGrid = $('#gridDeviceProduct').dxDataGrid('instance');
                                            $scope.pageSize = dataGrid.pageSize();
                                            pageindex = dataGrid.pageIndex();
                                            $scope.DeviceProductList = data;
                                            if (!$scope.isDeleteVisible) {
                                                $scope.cancelForm();
                                            }
                                            $scope.refreshGrid(pageindex);
                                        }).error(function (data) {
                                            masterFactory.setError(status, data, $scope);
                                        }).finally(function (data) {
                                            if ($scope.isDeleteVisible) {
                                                $scope.notify.add({ type: 'success', title: 'Success!', body: 'Updated Device Product successfully' });
                                            }
                                            else {
                                                $scope.notify.add({ type: 'success', title: 'Success!', body: 'Created Device Product successfully' });
                                            }
                                        });
                                    }).error(function (data, status) {
                                        masterFactory.setError(status, data, $scope);
                                    }).finally(function () {
                                        $('#loadingModal').modal('hide');
                                    });
                                };

                                // Helping functions and events
                                $(window).resize(function () {
                                    onWindowResize('#gridDeviceProduct', settings.GridMarginHeight);
                                });

                                function grdReadyAction(e) {
                                    onWindowResize('#gridDeviceProduct', settings.GridMarginHeight);
                                }

                                collapsibleHeaderClickEvent($scope);

                                $scope.closeAlert = function () {
                                    $scope.error = null;
                                };

                                $scope.closeModelStateErrors = function () {
                                    $scope.modelState = [];
                                };
                            }]);
